class AuraFeaturedReviews extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    this.track = this.querySelector('[data-aura-review-track]');
    this.prevButton = this.querySelector('[data-aura-review-prev]');
    this.nextButton = this.querySelector('[data-aura-review-next]');

    if (!this.track) return;

    this.handleScroll = this.updateControls.bind(this);

    this.prevButton?.addEventListener('click', () => {
      this.move(-1);
    });

    this.nextButton?.addEventListener('click', () => {
      this.move(1);
    });

    this.track.addEventListener('scroll', this.handleScroll, {
      passive: true
    });

    window.addEventListener('resize', this.handleScroll);

    this.updateControls();
  }


  disconnectedCallback() {
    if (!this.track) return;

    this.track.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }


  move(direction) {
    if (!this.track) return;

    this.track.scrollBy({
      left: this.track.clientWidth * direction,
      behavior: 'smooth'
    });
  }


  updateControls() {
    if (!this.track) return;

    const maximumScroll =
      this.track.scrollWidth - this.track.clientWidth;

    const currentScroll = this.track.scrollLeft;

    if (this.prevButton) {
      this.prevButton.disabled = currentScroll <= 4;
    }

    if (this.nextButton) {
      this.nextButton.disabled =
        currentScroll >= maximumScroll - 4;
    }
  }
}


if (!customElements.get('aura-featured-reviews')) {
  customElements.define(
    'aura-featured-reviews',
    AuraFeaturedReviews
  );
}